'use client';

// import LinkButton from '@/_components/Ui/LinkButton';
// import { urlFor, HERO_QUERYResult } from '@/_sanity';
import { HERO_QUERYResult } from '@/_sanity';
// import Image from 'next/image';
import Link from 'next/link';

const HeroBigBackgroundImage = ({ hero }: { hero: HERO_QUERYResult }) => {
  // const heroBgImageUrl = hero?.bgimage?.asset?._ref ? urlFor(hero.bgimage?.asset)?.url() : '';

  // const titleTextColor = 'stonerwhite';
  // const titleTextColor = `text-${hero?.titletextcolor?.label ?? 'policeblue'}`;
  // const catchPhraseTextColor = `text-${hero?.catchphrasetextcolor?.label ?? 'policeblue'}`;
  const catchPhraseTextColor = 'stonerwhite';

  // const ctaLeftBgColor = `bg-${hero?.ctaleftbgcolor?.label ?? 'policeblue'}`;
  // const ctaLeftBgColorHover = `hover:bg-${hero?.ctaleftbgcolorhover?.label ?? 'moonstoneblue'}`;
  // const ctaLeftTextColor = `text-${hero?.ctalefttextcolor?.label ?? 'stonerwhite'}`;
  // const ctaLeftTextColorHover = `hover:text-${hero?.ctalefttextcolorhover?.label ?? 'stonerwhite'}`;

  // const ctaRightBgColor = `bg-${hero?.ctarightbgcolor?.label ?? 'moonstoneblue'}`;
  // const ctaRightBgColorHover = `hover:bg-${hero?.ctarightbgcolorhover?.label ?? 'policeblue'}`;
  // const ctaRightTextColor = `text-${hero?.ctarighttextcolor?.label ?? 'policeblue'}`;
  // const ctaRightTextColorHover = `hover:text-${hero?.ctarighttextcolorhover?.label ?? 'stonerwhite'}`;

  const ctaRightText = hero?.ctarighttext || '';
  const ctaLeftText = hero?.ctalefttext || '';

  const linkBaseClass =
    'font-bold inline-block w-full rounded-lg px-4 py-2 3xl:px-8 3xl:py-4 text-center text-xl 3xl:text-2xl md:w-[220px] 3xl:w-[300px] transition-all duration-300 ease-in-out transform hover:scale-110';

  // const DisplayLeft = () => (
  //   <div className="relative flex w-full flex-col gap-4 p-4 py-4 md:pb-10 md:pl-10">
  //     <div className="flex w-full flex-col gap-4 md:w-[85%] lg:w-[65%] xl:w-[50%]">
  //       <h1 className="text-stonerwhite">Recruter autrement</h1>

  //       <div className={`text-stonerwhite flex flex-col gap-2`}>
  //         <h2>Capitaliser</h2>

  //         <h2>sur l&apos;expérience des&nbsp;talents&nbsp;45&nbsp;ans et plus</h2>

  //         <h2>pour&nbsp;bâtir&nbsp;l&apos;avenir</h2>
  //       </div>

  //       {hero?.catchphraseauthortext && (
  //         <h1 className={`text-${catchPhraseTextColor}`}>{hero?.catchphraseauthortext}</h1>
  //       )}
  //     </div>

  //     <div className="flex flex-col items-center gap-4 sm:flex-row">
  //       <Link
  //         href="#contact-section"
  //         className={`${linkBaseClass} text-stonerwhite bg-policeblue hover:bg-policeblue-dark hover:bordercolor-stonerwhite hover:border-2`}
  //       >
  //         {ctaLeftText}
  //       </Link>

  //       <Link
  //         href="#contact-section"
  //         className={`${linkBaseClass} text-policeblue bg-stonerwhite`}
  //       >
  //         {ctaRightText}
  //       </Link>
  //     </div>
  //   </div>
  // )

  const DisplayCenter = () => (
    <div className="gap-4 p-4 py-4 md:py-10 md:pl-10 flex w-full flex-col items-center">
      <div className="gap-8 md:gap-10 flex w-full flex-col items-center">
        <div className="gap-8 flex w-full flex-col items-center">
          <h1 className="text-stonerwhite text-center">
            <span className="3xl:text-7xl md:text-6xl">Recruter autrement</span>
          </h1>

          <div
            className={`text-stonerwhite gap-2 space-x-1 md:w-[85%] lg:w-[65%] xl:w-[55%] flex w-full flex-col text-center`}
          >
            <h2 className="leading-normal">
              Capitaliser sur l&apos;
              <span className="text-4xl font-bold md:text-5xl">expérience</span>
              <br />
              <span className="whitespace-nowrap"> des talents de +45 ans</span>
              <br />
              <span>
                pour&nbsp;consolider&nbsp;l&apos;
                <span className="text-4xl font-bold md:text-5xl">avenir</span>.
              </span>
            </h2>
          </div>

          {hero?.catchphraseauthortext && (
            <h1 className={`text-${catchPhraseTextColor}`}>{hero?.catchphraseauthortext}</h1>
          )}
        </div>

        <div className="gap-4 sm:flex-row md:w-[85%] lg:w-[65%] xl:w-[55%] flex w-full flex-col items-center justify-between">
          <Link
            href="#contact-section"
            className={`${linkBaseClass} text-stonerwhite bg-policeblue hover:bordercolor-stonerwhite hover:border-2`}
          >
            {ctaLeftText}
          </Link>

          <Link
            href="#contact-section"
            className={`${linkBaseClass} text-policeblue bg-stonerwhite`}
          >
            {ctaRightText}
          </Link>
        </div>
      </div>
    </div>
  );

  return (
    <section className="from-policeblue to-darkindigo px-4 sm:px-8 md:h-[60vh] md:px-10 lg:px-12 relative overflow-hidden bg-linear-to-t">
      {hero && (
        <div className="max-w-6xl m-auto flex h-full w-full">
          <div className="relative mx-auto flex w-full flex-col justify-center">
            {/* Image with object-fit */}
            {/* <div className="absolute inset-0 overflow-hidden">
              <Image
                src={heroBgImageUrl || ''}
                alt="Background visual"
                className="h-full w-full object-contain"
                width={1920}
                height={1440}
                priority
              />

              <div className="bg-darkstoner/40 absolute inset-0"></div>
            </div> */}

            {/* Foreground content */}
            {/* <DisplayLeft/> */}
            {DisplayCenter()}
          </div>
        </div>
      )}
    </section>
  );
};

export default HeroBigBackgroundImage;
